import axios from 'axios'

const tags = {}

tags.find = (identificador) => {
	const filters = {
		identificador: identificador
	}
	return axios.get('/tags', { params: filters })
}

tags.findByNome = (nome, identificador) => {
	const filters = {
		nome: nome,
		identificador: identificador
	}
	return axios.get('/tags', { params: filters })
}

export { tags }
